export const getAllTags = state => state.tagsService.tags;
